import BaseService from '_services/rest/base';

class ServiceService extends BaseService {
  constructor() {
    super();
  }

  deleteService(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/service`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search, project_id: params.project_id || null };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getServiceById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(service) {
    const meta = this.getUrlSave(service.id, '');
    return this.request(meta.url, service, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ServiceService();
